import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.boundClose = this.closeOnClickOutside.bind(this)
  }

  toggle(event) {
    event.stopPropagation()

    const isCurrentlyOpen = !this.menuTarget.classList.contains("hidden")

    // Close all other dropdowns (but not this one)
    document.querySelectorAll("[data-controller~='dropdown']").forEach(element => {
      const controller = this.application.getControllerForElementAndIdentifier(element, "dropdown")
      if (controller && controller !== this) {
        controller.close()
      }
    })

    // Toggle this dropdown
    if (isCurrentlyOpen) {
      this.close()
    } else {
      this.menuTarget.classList.remove("hidden")
      document.addEventListener("click", this.boundClose)
    }
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  close() {
    this.menuTarget.classList.add("hidden")
    document.removeEventListener("click", this.boundClose)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClose)
  }
}
